import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eabfdd0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redpack-info-symbol" }
const _hoisted_2 = { class: "red-pack-info-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "red-pack-desc" }
const _hoisted_5 = { class: "red-pack-title" }
const _hoisted_6 = { class: "text-opacity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chain_tag = _resolveComponent("chain-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.symbolInfo.logo,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("v1.0.redPackName", { symbol: _ctx.redPackBasicInfo.denom })), 1),
        _createVNode(_component_chain_tag, { chainId: _ctx.chainId }, null, 8, ["chainId"])
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("v1.0.redPackFrom", {
            address: _ctx.$tools.captureAddress(_ctx.redPackBasicInfo.sender),
          })), 1)
    ])
  ]))
}